var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCloseWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.474 4.47132C12.7344 4.21097 12.7344 3.78886 12.474 3.52851C12.2137 3.26816 11.7915 3.26816 11.5312 3.52851L8.0026 7.05711L4.47401 3.52851C4.21366 3.26816 3.79155 3.26816 3.5312 3.52851C3.27085 3.78886 3.27085 4.21097 3.5312 4.47132L7.0598 7.99992L3.5312 11.5285C3.27085 11.7889 3.27085 12.211 3.5312 12.4713C3.79155 12.7317 4.21366 12.7317 4.47401 12.4713L8.0026 8.94273L11.5312 12.4713C11.7915 12.7317 12.2137 12.7317 12.474 12.4713C12.7344 12.211 12.7344 11.7889 12.474 11.5285L8.94541 7.99992L12.474 4.47132Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCloseWhite);
export default __webpack_public_path__ + "static/media/ic-close-white.45701f907730ef27b95d6dc8c2fc3721.svg";
export { ForwardRef as ReactComponent };